import { type ReactElement, type SVGProps } from 'react';

export const SurfaceLivingShopIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.5 1.793 1.646 3.647l.708.707L3 3.707v13.086l-.646-.646-.708.707L3.5 18.708l1.854-1.854-.708-.707-.646.646V3.707l.646.647.708-.707L3.5 1.793ZM7 3v8h6v6h8V3H7Zm1 7V7.707L11.707 4h3.086l-6 6H8Zm2.207 0 6-6h3.086l-6 6h-3.086ZM14 15.207V16h2.293L20 12.293V9.207l-6 6Zm0-1.414 6-6V4.707l-6 6v3.086ZM10.293 4 8 6.293V4h2.293Zm7.414 12H20v-2.293L17.707 16Zm4.5 4.5-1.853 1.854-.707-.707.646-.647H7.207l.647.646-.708.708L5.293 20.5l1.853-1.854.708.708-.647.646h13.086l-.646-.646.707-.707 1.854 1.853Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
